import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type State = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useCreateScheduleModalStore = createWithEqualityFn<State>()(
  (set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }),
  shallow
);
